import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import Swal from 'sweetalert2';
import { Util } from './app/model/Util';
util: Util

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => err.toString());

  var idleTime = 0;
  (function () {
    var idleInterval = setInterval(timerIncrement, 300000);

    document.addEventListener("mouseover", () => {
      idleTime = 0;
    });
    document.addEventListener("keydown", () => {
      idleTime = 0;
    });
  })();

    function timerIncrement() {
      const url = environment.apiUrl+'authentication/signin';
      var path = window.location.href;
      if (path !== url) {
        idleTime ++;
        if (idleTime == 2) {
          // 10 minutes
          sessionStorage.clear();
          localStorage.clear();
          window.location.assign(url);
          showTitleErorIcon();
        }
      }
    }

    function showTitleErorIcon() {
      Swal.fire({
        icon: 'error',
        title: 'Sesión cerrada',
        text: 'Por inactividad, el aplicativo cerró la sesión',
      });
    }



